// extracted by mini-css-extract-plugin
export default {"wrap":"it-z","fullWidth":"jt-z","items":"kt-z","featureCss":"lt-z","disabled":"mt-z","imgCss":"nt-z"};